import { CallApiResult, callTemplateApi } from 'src/api';

type TemplateType = 'PLAIN_TEXT' | 'NAMESPACE';

export interface TemplateResponse {
    type: TemplateType;
    value: string;
    templateKey?: string;
}

/**
 * Calls the api for the authenticated account
 */
export const fetchNamespacedTemplates = (
    language: string,
    region: string,
    ns: string
): Promise<CallApiResult<TemplateResponse | TemplateResponse[]>> => {
    // For the translation template fetching we can't rely on the language and region headers
    // set in axios.defaults to be up-to-date; Make sure to add them herer explicitly
    return callTemplateApi(`/template/content/${ns}`, {
        headers: {
            language,
            region,
        },
    });
};

export const getLocalizedTemplateContent = (templateKey: string): Promise<CallApiResult> => {
    return callTemplateApi('/template/' + templateKey);
};

/** Several text blocks in one read (templating `GET /template/contents`); unknown keys are left out. */
export const fetchTemplateContents = (
    templateKeys: string[],
    language: string,
    region: string
): Promise<CallApiResult<TemplateResponse[]>> =>
    callTemplateApi('/template/contents', {
        params: { templateKeys: templateKeys.join(',') },
        headers: { language, region },
    });
